
"use client";

import Image from "next/image";
const hostelImages = [
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00732-min.JPG",
    alt: "Modern hostel building with secure campus environment"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00740-min.JPG",
    alt: "Spacious hostel rooms with natural lighting"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00752-min.JPG",
    alt: "Comfortable student accommodation facilities"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00753-min.JPG",
    alt: "Well maintained hostel interiors for students"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00757-min.JPG",
    alt: "Safe and hygienic hostel environment"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00760-min.JPG",
    alt: "Student friendly hostel infrastructure"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00761-min.JPG",
    alt: "Common areas designed for student comfort"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00763-min.JPG",
    alt: "Peaceful hostel surroundings inside campus"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC06194.jpg",
    alt: "Fully furnished hostel rooms for students"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC06197.jpg",
    alt: "Clean and organized student hostel facilities"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC06200.jpg",
    alt: "Campus hostel offering safe student living"
  }
];
const Hostelimages = () => {
  const marqueeItems = [...hostelImages, ...hostelImages];

  return (
    <div className="w-full overflow-hidden">
      <div
        className="flex gap-5 marquee overflow-hidden"
        style={{ "--speed": "150s" }}
      >
        {marqueeItems.map((item, index) => (
          <div
            key={index}
            className="min-w-[250px] md:min-w-[320px] lg:min-w-[500px] 
              relative overflow-hidden group transition-transform 
              duration-700 hover:scale-105"
          >
            <Image
              src={item.img}
              alt={item.alt}
              width={500}
              height={300}
              unoptimized
              className="object-cover w-full h-[200px] md:h-[260px] lg:h-[320px]
                transition-transform duration-700 group-hover:scale-110"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hostelimages;
